import React, {useState} from 'react'
import './VedioSidbar.scss';
import FavoriteIcon from '@material-ui/icons/Favorite';
import MessageIcon from '@material-ui/icons/Message';
import ShareIcon from '@material-ui/icons/Share';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';

const VedioSidbar = ({likes , shares , messages}) => {
  
  const [liked , setLiked] = useState(false)
  const [msgd , setMsgd] = useState(false)
  const [shard , setShard] = useState(false)

  return (
  	// BEM naming convention
    <div className="vedioSidbar">
	    <div className="vedioSidbar__button">
	    	{liked ? (
	    		<FavoriteIcon
	    			fontSize={"large"}
	    			onClick={(e) => setLiked(false)}
	    			/>
	    		) : 
	    		(
	    			<FavoriteBorderIcon
	    				fontSize={"large"}
	    				onClick={(e) => setLiked(true)}
	    				/>
	    		)
	    	}
	    	
	    	<p>{liked ? parseInt(likes) + 1 : parseInt(likes)}</p>
	    </div>

	    <div className="vedioSidbar__button">
	    	{msgd ? (
	    		<MessageIcon
	    			fontSize={"large"}
	    			onClick={(e) => setMsgd(false)}
	    			/>
	    		) : 
	    		(
	    			<MessageIcon
	    				fontSize={"large"}
	    				onClick={(e) => setMsgd(true)}
	    				/>
	    		)
	    	}
	    	<p>{msgd ? parseInt(messages) + 1 : parseInt(messages)}</p>
	    </div>

	    <div className="vedioSidbar__button">
	    	{shard ? (
	    		<ShareIcon
	    			fontSize={"large"}
	    			onClick={(e) => setShard(false)}
	    			/>
	    		) : 
	    		(
	    			<ShareIcon
	    				fontSize={"large"}
	    				onClick={(e) => setShard(true)}
	    				/>
	    		)
	    	}

	    	<p>{shard ? parseInt(shares) + 1 : parseInt(shares) }</p>
	    </div>
    </div>
  );
}

export default VedioSidbar;
